/**
 * Created by Miguel on 23/05/2017
 */
import { Component, HostListener,OnInit, Input, ViewChild,ChangeDetectionStrategy, ViewEncapsulation,SimpleChanges  } from '@angular/core';
import { ActivatedRoute,RouterLink} from '@angular/router';
import { DomSanitizer,  SafeResourceUrl , SafeHtml } from '@angular/platform-browser';
import {Router} from "@angular/router";
import { AppDataService }  from '../../../services/app-data.service';
import { CompanyService }  from '../../../services/company.service';

declare var $ : any;

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector : 'movie-list-modal',
    templateUrl:'movie-list-modal.html',
    providers  : [],  
})
export class MovieListModal implements OnInit {
  public list;
    public ngOnInit() : any {
      this.list=[]
      if (!this._appData.instagramUser) return;
      if (!this._appData.room) return;
      this._companyService.getVideoToRoomList(this._appData.room.id).get().then(val=>{
        this.list=[]
        val.forEach(v=>{
          let mov=v.data();
          let d=mov.date
          let date=new Date(d)
          mov.data=date.toLocaleString(); // expected output: "7/25/2016, 1:35:07 PM"
          this.list.push(mov)
        })
      })
    }
    public change() {

    }
    constructor( public _appData : AppDataService,private _companyService : CompanyService,public _sanitizer: DomSanitizer,public _router : Router,private _routeParams : ActivatedRoute) {
    }

}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/movie-list-modal/movie-list-modal.ts